import { render, staticRenderFns } from "./UserRestrictionsModal.vue?vue&type=template&id=4f4fcdb9"
import script from "./UserRestrictionsModal.vue?vue&type=script&lang=js"
export * from "./UserRestrictionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports